module.exports = __webpack_public_path__ + "img/hour24.ba92809d.png";